import { render } from "./WorkingSiteClockingInsSection.vue?vue&type=template&id=56739a1e&scoped=true&ts=true&lang=pug"
import script from "./WorkingSiteClockingInsSection.vue?vue&type=script&lang=ts"
export * from "./WorkingSiteClockingInsSection.vue?vue&type=script&lang=ts"

import "./WorkingSiteClockingInsSection.vue?vue&type=style&index=0&id=56739a1e&lang=scss&scoped=true"

import exportComponent from "/Users/massimodeluisa/Git/Smart Squad/Sultan/CMS Admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56739a1e"]])

export default __exports__